import type { InsuranceIndex } from '../../../types/InsuranceFeatureConfig';
import type { ClaimsFeatureConfig } from '../../../types/features/ClaimsFeatureConfig';
import { claims as base } from './base';
import { claims as AT } from './AT';
import { claims as CZ } from './CZ';
import { claims as HR } from './HR';
import { claims as HU } from './HU';
import { claims as RO } from './RO';
import { claims as RS } from './RS';
import { claims as SK } from './SK';

export const claimsConfig: InsuranceIndex<ClaimsFeatureConfig> = {
    base,
    AT,
    CZ,
    HR,
    HU,
    RO,
    RS,
    SK,
};
